import React, { useState } from 'react'
import NavLink from './NavLink'
import { useKeyboardIndex } from './useKeyboardIndex'

const NavSubMenu = ({
    items,
    menuId,
    isExpanded,
    index,
    handleKeyDown,
    handleOnFocus
}) => {
    const styles = {
        display: isExpanded ? 'block' : 'none'
    }

    return (
        <ul id={menuId}  style={styles}>
            {items.map((item, i) => (
                <li key={item.id} style={styles}>
                    <NavLink
                        item={item}
                        hasFocus={index === i}
                        handleOnFocus={() => handleOnFocus(i)}
                        handleKeyDown={handleKeyDown}
                    />
                </li>
            ))}
        </ul>
    )
}

export default NavSubMenu